import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./App.scss";
import "antd-mobile/dist/antd-mobile.css";

ReactDOM.render(<App />, document.getElementById("root"));
